import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import { Tracert } from "../core/index";
import { getUuid } from "../utils";

// 存储路径
var cachePath = [];
var pathUserMeta = {};

/**
 * 组装漏斗参数
 * @param config string 自定义漏斗 对象 标准漏斗
 */
function getFunnelExtra(config) {
  if (!config) {
    // console.warn('getFunnelParam param is invalid')
    return {};
  }

  // 参数校验
  if (_typeof(config) === 'object') {
    if (!(config !== null && config !== void 0 && config.name)) {
      console.warn('funnel_name is empty');
    }
    if (!(config !== null && config !== void 0 && config.level)) {
      console.warn('funnel_level is empty');
    }
    if (!(config !== null && config !== void 0 && config.label)) {
      console.warn('funnel_label is empty');
    }
  }

  // 自定义漏斗
  if (typeof config === 'string') {
    return {
      funnel_level_alias: config
    };
  } else {
    var _config$name, _config$level, _config$label, _config$alias, _config$immediate;
    // 标准漏斗参数
    return _objectSpread(_objectSpread({}, config), {}, {
      funnel_name: (_config$name = config === null || config === void 0 ? void 0 : config.name) !== null && _config$name !== void 0 ? _config$name : '',
      funnel_level: (_config$level = config === null || config === void 0 ? void 0 : config.level) !== null && _config$level !== void 0 ? _config$level : -1,
      funnel_level_label: (_config$label = config === null || config === void 0 ? void 0 : config.label) !== null && _config$label !== void 0 ? _config$label : '',
      funnel_level_alias: (_config$alias = config === null || config === void 0 ? void 0 : config.alias) !== null && _config$alias !== void 0 ? _config$alias : '',
      immediate: (_config$immediate = config === null || config === void 0 ? void 0 : config.immediate) !== null && _config$immediate !== void 0 ? _config$immediate : false
    });
  }
}

/**
 * 解析成功率上报参数
 * @param key p_ page c_ click expo r l -info或者-error结尾是前端日志
 * @param funnelConfig 标准漏斗上报参数
 * @returns 扩展参数数据
 */
function parseUserPathExtra(key) {
  // const chInfo = '' // getChInfo()
  if (typeof key !== 'string') {
    return null;
  }
  cachePath.push(key);
  var extra = {
    // 防止太长，影响日志上报，暂定最长1200个字符
    idengine_user_path: cachePath.join('|').slice(0, (Tracert === null || Tracert === void 0 ? void 0 : Tracert.get('userPathLength')) || 1200)
  };
  return extra;
}

/**
 * 外跳时存储用户路径，回跳后恢复用户路径
 */
function storeUserPath(appId) {
  if (typeof window === 'undefined') return;

  // 存储用户路径
  if (cachePath.length) {
    sessionStorage.setItem(appId ? "".concat(appId, "_idengine_user_path") : 'idengine_user_path', cachePath.join('|'));
  }

  // 存储sessionId
  storeSessionId(appId);

  // 存储业务元数据
  storeUserPathMdata(appId);
}

/**
 * 恢复存储的用户路径
 */
function reStoreUserPath(appId) {
  if (typeof window === 'undefined') return;
  // 恢复用户路径
  var path = sessionStorage.getItem('idengine_user_path') || sessionStorage.getItem("".concat(appId, "_idengine_user_path"));
  if (path) {
    cachePath = path.split('|');
    sessionStorage.removeItem('idengine_user_path');
    sessionStorage.removeItem("".concat(appId, "_idengine_user_path"));
  }

  // 恢复业务元数据
  reStoreUserPathMeta(appId);

  // 恢复sessionId
  reStoreSessionId(appId);
}
function reStoreUserPathMeta(appId) {
  if (typeof window === 'undefined') return;
  var pathMeta = sessionStorage.getItem('idengine_path_mdata') || sessionStorage.getItem("".concat(appId, "_idengine_path_mdata")) || '';
  if (pathMeta) {
    try {
      pathUserMeta = JSON.parse(pathMeta);
      var metaDatas = [];
      Object.keys(pathUserMeta).forEach(function (item) {
        metaDatas.push(pathUserMeta[item]);
      });
      Tracert === null || Tracert === void 0 ? void 0 : Tracert.set({
        mdata: {
          idengine_path_mdata: metaDatas.join('|')
        }
      });
    } catch (e) {
      console.error(e);
    }
  }
  sessionStorage.removeItem('idengine_path_mdata');
  sessionStorage.removeItem("".concat(appId, "_idengine_path_mdata"));
}
function reStoreSessionId(appId) {
  if (typeof window === 'undefined') return;
  // 跳到第三方应用如3ds，再回跳。继续用之前的sessionId，保障用户路径延续
  var sessionId = sessionStorage.getItem('idengine_sessionId') || sessionStorage.getItem("".concat(appId, "_idengine_sessionId")) || '';
  if (sessionId) {
    Tracert === null || Tracert === void 0 ? void 0 : Tracert.set({
      sessionId: sessionId
    });
    sessionStorage.removeItem('idengine_sessionId');
    sessionStorage.removeItem("".concat(appId, "_idengine_sessionId"));
  }
}

// 设置用户路径分析业务属性
var setUserPathMdata = function setUserPathMdata(_ref) {
  var key = _ref.key,
    value = _ref.value;
  if (!key || !value) return;
  if (value.indexOf('|') >= 0) {
    console.warn('user path mdata can not include | char');
    // eslint-disable-next-line no-param-reassign
    value = value.replace(/\|/g, '');
  }
  pathUserMeta[key] = value;
  var metaDatas = [];
  Object.keys(pathUserMeta).forEach(function (item) {
    metaDatas.push(pathUserMeta[item]);
  });
  Tracert === null || Tracert === void 0 ? void 0 : Tracert.set({
    mdata: {
      idengine_path_mdata: metaDatas.join('|')
    }
  });
};

// 重置session id
var resetSessionId = function resetSessionId() {
  Tracert === null || Tracert === void 0 ? void 0 : Tracert.set({
    sessionId: getUuid()
  });
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('idengine_sessionId');
    sessionStorage.removeItem("".concat(Tracert === null || Tracert === void 0 ? void 0 : Tracert.get('appId'), "_idengine_sessionId"));
  }
};

// 存储session id
function storeSessionId(appId) {
  if (typeof window !== 'undefined') {
    var sessionId = Tracert === null || Tracert === void 0 ? void 0 : Tracert.get('sessionId');
    if (sessionId) {
      sessionStorage.setItem(appId ? "".concat(appId, "_idengine_sessionId") : 'idengine_sessionId', sessionId);
    }
  }
}

// 重置用户路径
var resetUserPath = function resetUserPath() {
  // 重置sessionId
  resetSessionId();

  // 重置业务属性
  pathUserMeta = {};
  Tracert === null || Tracert === void 0 ? void 0 : Tracert.set({
    mdata: {
      idengine_path_mdata: ''
    }
  });

  // 重置用户路径
  cachePath.length = 0;
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('idengine_user_path');
    sessionStorage.removeItem("".concat(Tracert === null || Tracert === void 0 ? void 0 : Tracert.get('appId'), "_idengine_user_path"));
    sessionStorage.removeItem('idengine_path_mdata');
    sessionStorage.removeItem("".concat(Tracert === null || Tracert === void 0 ? void 0 : Tracert.get('appId'), "_idengine_path_mdata"));
  }
};

// 存储业务属性
function storeUserPathMdata(appId) {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(appId ? "".concat(appId, "_idengine_path_mdata") : 'idengine_path_mdata', JSON.stringify(pathUserMeta));
  }
}
var setUserPath = function setUserPath(path) {
  if (!path) return;
  cachePath = path;
};
var getUserPath = function getUserPath() {
  return cachePath;
};
export { getFunnelExtra, parseUserPathExtra, storeUserPath, reStoreUserPath, resetSessionId, resetUserPath, setUserPathMdata, setUserPath, getUserPath };